import { postJson } from './api'

/** Browser + client-side check before calling the join-us API. */
export const JOIN_US_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i

export const JOIN_US_SUCCESS_MESSAGE =
  'Thanks — check your inbox for a confirmation from ASSET.'

/** Who We Serve & What We Do — success line auto-clear (ms). */
export const JOIN_US_SUCCESS_AUTO_HIDE_MS = 4000

/** Home hero join banner — success line auto-clear (ms). */
export const JOIN_US_SUCCESS_AUTO_HIDE_MS_HERO = 5000

export async function submitJoinUsEmail(trimmedEmail) {
  const { response, result } = await postJson('/api/join-us', { email: trimmedEmail })
  if (!response.ok || !result.ok) {
    throw new Error(result.message || 'Something went wrong. Please try again.')
  }
  return result
}
